import React from 'react';
import styles from './Dropdown.module.scss';
import classNames from 'classnames';

export type DropdownItem = {
  key: string;
  label: string;
  id: string;
};

interface Dropdown {
  ariaLabel?: string;
  options: DropdownItem[];
  onItemSelected: (id: string) => void;
  onClose: () => void;
  plain?: boolean;
  placeholder?: boolean;
  value?: string;
}

const Dropdown: React.FC<Dropdown> = ({
  ariaLabel,
  options,
  onItemSelected,
  plain,
  placeholder,
  value
}) => {
  return (
    <select
      id={ariaLabel}
      aria-label={ariaLabel}
      autoComplete="off"
      className={classNames(styles.dropdown, {
        [styles.plain]: plain,
        [styles.placeholder]: placeholder
      })}
      onChange={(event) => {
        onItemSelected(event.target.value);
      }}
      value={value}
    >
      {options.map(({ key, label }) => (
        <option aria-label={label} key={key} value={key}>
          {label}
        </option>
      ))}
    </select>
  );
};

export default Dropdown;
